// import { isAsyncThunkAction, AnyAction } from '@reduxjs/toolkit';
// eslint-disable-next-line no-duplicate-imports
import { useDispatch } from 'react-redux';

import { TDispatch } from 'shared/types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
// export const useAppDispatch = (): TDispatch => {
//   const dispatch = useDispatch<TDispatch>();

//   return (action: AnyAction) => {
//     if (isAsyncThunkAction(action)) {
//       return (dispatch(action) as ReturnType<typeof action>).unwrap();
//     }

//     return dispatch(action);
//   };
// };
